export default {
  title: "Share the news", // Поделиться новостями
  description:
    "In this section you can apply for placing the information about your company’s products or news on the exhibition website, in the online catalogue.", // В данном разделе вы можете оставить заявку на размещение информации о вашей продукции или новостей о вашей компании на сайте выставки.
  sendButtonText: "Send an application", // Отправить заявку
  modal: {
    title: "Share the news", // Поделиться новостями
    title2: "Apply", // Подать заявку
    blueButtonText: "Add an application", // Добавить заявку
    commentMaxLength: "Up to {count} characters", // До {count} символов
    commentLabel: "Comment/note", // Комментарий/примечание к размещению
    headingInput: "Title", // Заголовок
    headingMaxLength: "Up to {count} characters", // До {count} символов

    applicationTypesLabel: "Type of an application", // Тип заявки
    applicationTypesNewsOption: "News", // Новость
    applicationTypesProductOption: "Products", // Продукция

    dropzoneDownloadImages: "Upload image", // Загрузить изображение
    dropzoneDropFiles: "Drag and drop files here", // Перетащите сюда файлы
    dropzoneChooseFiles: "Select files", // Выберите файлы
    dropzoneFileSizeLimit:
      "Maximum number of files: {count}, maximum file size: {mb}MB", // Максимальное количесвто файлов:{count}, максимальный размер файла: {mb}Мб
    dropzoneFilesType: "Allowed file types", // Достимые типы файлов
    dropzoneFileType: "Allowed file types", // Достимые типы файла
    dropzoneMaxFileSize: "Maximum file size", // Максимальный размер
    dropzoneMaxFileSizeMessage: "Maximum number of files", // Максимальное количество файлов

    textEditorPlaceholder: "Up to {count} characters", // До {count} символов
    textEditorToolsLabel: "Styles:",
    textEditorLabel: "Description",

    fieldError: "Can not be empty", // Поле не может быть пустым

    typeNews: "News", // Новость
    typeProduct: "Products", // Продукция

    publicationLink: "Link to the publication", // Ссылка на публикацию
    commentBlockHeading: "Posting comment", // Комментарий к размещению
    rejectReason: "Reason for rejection", // Причина отклонения

    statuses: {
      publish: "Publish", // Опубликовано
      draft: "New", // Новая
      reject: "Reject", // Отклонено
      progress: "In work" // В работе
    }
  }
};
